import { Snackbar, SnackbarProps } from "@mui/material";
import { defaultProps } from "../../../../helpers/common";

export type AppAlertProps = SnackbarProps;

function AppAlert(props: AppAlertProps) {
    const snackbarProps: SnackbarProps = defaultProps(props, {
        anchorOrigin: {
            vertical: "top",
            horizontal: "center",
        },
        autoHideDuration: 3000,
    });

    return <Snackbar {...snackbarProps} />;
}

export default AppAlert;
